import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

// @material-ui/core
import { makeStyles } from "@mui/styles";
import { ArrowRightAlt } from "@mui/icons-material";
// core components
import { Stack, Grid, Box } from "@mui/material";

import TransactionsListDashboard from "views/Admin/TransactionsListDashboard";

import banner2 from "assets/img/banner2.webp";

import { dashboardStyle, ButtonExit } from "components/dashboardStyle.js";

const useStyles = makeStyles(dashboardStyle);

export default function Dashboard() {
  const classes = useStyles();

  const [buttonTransaction, setButtonTransaction] = useState(false);
  const [buttonClients, setButtonCLients] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (buttonTransaction) {
    return <Navigate to="/account/pending-transactions" />;
  }

  if (buttonClients) {
    return <Navigate to="/account/clients" />;
  }

  return (
    <div>
      <Box className={classes.cardDashboardTop} sx={{ mt: { xs: 8, sm: 1 } }}>
        <Grid container>
          <Grid item xs={12} md={8}>
            <Stack direction="row" spacing={2}>
              <span style={{ fontSize: 18, color: "#fff" }}>
                Bienvenido administrador a tu dashboard
              </span>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Grid container sx={{ mb: 5 }}>
        <Grid item xs={12} md={12}>
          <div className={classes.cardDashboardText} style={{ marginTop: 10 }}>
            <div style={{ fontSize: 24, color: "#000", padding: "5px 40px" }}>
              <span style={{ fontWeight: 550 }}>
                Plataforma de link de pagos
              </span>
              <br></br>
              <span style={{ fontSize: 16 }}>
                Control y acceso completo para la creación, administración y
                seguimiento de links de pago para empresas. Establece límites y
                monitorea transacciones en tiempo real.
              </span>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={8} sx={{ py: 1 }}>
          <TransactionsListDashboard />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", flexDirection: "column", py: 4, px: 2 }}
        >
          <center>
            <img
              src={banner2}
              alt={`firsttimetamplate1`}
              style={{
                width: "75%",
                objectFit: "container",
              }}
            />
          </center>
          <div className={classes.carDashboard}>
            <Grid container>
              <Grid item>
                <ButtonExit
                  endIcon={<ArrowRightAlt />}
                  onClick={() => setButtonCLients(true)}
                >
                  IR AL MÓDULO DE CLIENTES
                </ButtonExit>
              </Grid>
              <Grid item>
                <ButtonExit
                  endIcon={<ArrowRightAlt />}
                  onClick={() => setButtonTransaction(true)}
                >
                  IR AL MÓDULO PENDIENTE POR PAGAR
                </ButtonExit>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
